import {
  collection,
  addDoc,
  query,
  where,
  getDocs,
  serverTimestamp
} from 'firebase/firestore';
import { db } from './config';

const COLLECTION = 'clients';

export const clientService = {
  async findByEmail(email) {
    const q = query(collection(db, COLLECTION), where('email', '==', email.toLowerCase()));
    const snapshot = await getDocs(q);
    if (snapshot.empty) {
      return null;
    }
    const doc = snapshot.docs[0];
    return {
      id: doc.id,
      ...doc.data()
    };
  },

  async create(data) {
    const clientData = {
      name: data.name,
      email: data.email.toLowerCase(),
      phone: data.phone || '',
      status: 'active',
      tags: ['New'],
      notes: '',
      totalBookings: 0,
      totalSpent: 0,
      totalAppointments: 0,
      lastVisit: null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    const docRef = await addDoc(collection(db, COLLECTION), clientData);

    // Log to security logs for monitoring
    try {
      await addDoc(collection(db, 'securityLogs'), {
        action: 'create',
        collection: 'clients',
        documentId: docRef.id,
        userId: null, // Public form submission
        userEmail: data.email.toLowerCase(),
        before: null,
        after: {
          name: data.name,
          email: data.email.toLowerCase(),
          status: 'active',
          tags: ['New']
        },
        changedFields: null,
        recaptchaScore: null,
        ip: null,
        userAgent: navigator.userAgent,
        timestamp: serverTimestamp()
      });
    } catch (err) {
      console.error('Error logging to securityLogs:', err);
    }

    return { id: docRef.id, ...clientData };
  },

  async findOrCreate(data) {
    const existing = await this.findByEmail(data.email);
    if (existing) {
      return { client: existing, isNew: false };
    }
    const newClient = await this.create(data);
    return { client: newClient, isNew: true };
  }
};

export default clientService;
